<div class="full-screen-modal">
  <header>
    <h2 class="title">Approved Vouchers</h2>
    <i class="close-btn material-icons" (click)="closeView()">close</i>
  </header>
  <div class="main-content">
    <h3>Select vouchers you wish to generate</h3>
    <div class="loan-list-wrapper">
      <div class="loan-list" *ngFor="let application of applications">
        <div class="loan new-card primary">
          <div class="loan-icon">
            <div class='img' [style.background-image]="'url(' + s3Url + '/logo-icons/' + (application.MerchantName | lowercase) + '-logo-icon.png)'"></div>
          </div>
          <div class="desc">
            <div class="loan-info primary">
              <span>{{application.MerchantName}}</span><span>{{application.LoanAmount | RupeeCurrencyPipe}}</span>
            </div>
            <div class="loan-info secondary">
              <span>{{application.NumberOfMonths}} months</span><span>at {{application.EmiAmount | RupeeCurrencyPipe}} / m</span>
            </div>
          </div>
          <div class="loan-selector">
            <input type="checkbox" class="filled-in" [id]="application.ExternalId" checked="checked" (click)="toggleApplicationSelection(application)"  />
            <label [for]="application.ExternalId"></label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <div class="info">You will be generating your voucher code(s). Once you get the voucher it cannot be cancelled.</div>
    <div class="modal-footer">
      <button class="btn zest-btn outline" (click)="cancelApplications(selectedApplications)" [disabled]='!selectedApplications.length'>CANCEL</button>
      <button class="btn zest-btn primary" (click)="generateVouchers(selectedApplications)" [disabled]='!selectedApplications.length'>GET VOUCHER ({{selectedApplications.length}})</button>
    </div>
  </footer>
</div>